import { render } from "./MediaCard.vue?vue&type=template&id=8a9111f8&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"

import "./MediaCard.vue?vue&type=style&index=0&id=8a9111f8&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a9111f8"]])

export default __exports__